var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M7.938 3.79a3.79 3.79 0 0 1 3.79 3.789V12H9.2V7.58a1.263 1.263 0 1 0-2.526 0V12H4.148V7.58a3.79 3.79 0 0 1 3.79-3.79M2.526 4.42H0V12h2.526zM1.263 2.526a1.263 1.263 0 1 0 0-2.526 1.263 1.263 0 0 0 0 2.526"
  })));
};
export default SvgLinkedin;